import React from "react";
import CreditManagement from "../CreditManagement";

const SellerTransferHistoryManagement = () => {
    return <CreditManagement managementType="seller" />;
};

export default SellerTransferHistoryManagement;
